import React from 'react'
import styles from './Skills.module.css'

const Skills = () => {
  return (
    <div id='skill_section'>
        <h1 className={styles.heading}>Skills</h1>
        <div className={styles.maincont}>
            
        <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/h6jigVrU1PVNtc8pqhaNyhysNbqLL-5zHO9W1jfeHKc/rs:fit:474:225:1/g:ce/aHR0cHM6Ly90c2Uz/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC54/WFBfVlZMVzJwb2RL/T3hPSjgwVVJRSGFI/YSZwaWQ9QXBp' alt='Html'/>
                <p className={styles.text}>HTML</p>
            </div>
            <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/TUEScxLhLRL4K5oCciCWa7ihAmQarNIeNzHmoJKJBwo/rs:fit:395:225:1/g:ce/aHR0cHM6Ly90c2Ux/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC54/aG56aEhjb3J2T1RE/empMVmcwTEF3SGFJ/NCZwaWQ9QXBp' alt='Css'/>
                <p className={styles.text}>CSS</p>
            </div>
            <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/_qJgzdfGc9kVrn34I88ejaHFfV7kUjoNrF49VVu9GMo/rs:fit:474:225:1/g:ce/aHR0cHM6Ly90c2Uy/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5J/NVhPaDlvX2tiVE5z/WG5zSWM1M2FBSGFI/YSZwaWQ9QXBp' alt='JavaScript'/>
                <p className={styles.text}>JavaScript</p>
            </div>
            <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/M-f1Tch-GFE-Jm4CEEn9RSGf3yle31dC1caFJeKfMBk/rs:fit:474:225:1/g:ce/aHR0cHM6Ly90c2Uz/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC41/R3NmQUxaQ0FjM0Rs/TGpLcUJMd2ZnSGFI/YSZwaWQ9QXBp' alt='React'/>
                <p className={styles.text}>React</p>
            </div>
            <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/XVmQ4nuy9-3R2ZhQ-Yz2WAKfOYm47iS4jSBZGjF8miM/rs:fit:524:225:1/g:ce/aHR0cHM6Ly90c2Ux/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC55/UFJOODdDOXZqcmR0/SUJZN1VUQWlBSGFH/cyZwaWQ9QXBp' alt='Redux'/>
                <p className={styles.text}>Redux</p>
            </div>
           
            <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/iFNb9D1arurJ_dsB5sEOKFsIs5etJwUMN00-Z3TCkS0/rs:fit:474:225:1/g:ce/aHR0cHM6Ly90c2Ux/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5T/d0k0Sk5jb2s2eWo4/YjZhME15a3ZnSGFI/YSZwaWQ9QXBp' alt='TypeScript'/>
                <p className={styles.text}>TypeScript</p>
            </div>
            <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/TdMohCF5jDPE3Qgo94uj5PLnYQRKcFaGq4uklYKnKRI/rs:fit:200:225:1/g:ce/aHR0cHM6Ly90c2Uz/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5s/UmIwN04zNGhjc05L/dWZ4VldrRm9BQUFB/QSZwaWQ9QXBp' alt='Chakra UI'/>
                <p className={styles.text}>Chakra UI</p>
            </div>
            <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/09iKbJAwNFGuiJAILJaetLxLKCgAhcNm4TzFb_Rj3dY/rs:fit:409:225:1/g:ce/aHR0cHM6Ly90c2Ux/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5s/XzVSclh2ZkVBWGlo/Wkp3MHludmNRSGFJ/ayZwaWQ9QXBp' alt='Mongo DB'/>
                <p className={styles.text}>Mongo DB</p>
            </div>
            <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/AzJYqBjLEFhzXr4bVw8vc12xty9tN8ukaTXEVcS_vvk/rs:fit:881:225:1/g:ce/aHR0cHM6Ly90c2U0/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC5T/eExkUVdOUUFZTl9U/LVh3TGVtbTZ3SGFE/XyZwaWQ9QXBp' alt='Node JS'/>
                <p className={styles.text}>Node JS</p>
            </div>
            <div className={styles.cont}>
                <img className={styles.img} src='https://imgs.search.brave.com/Qp_9r3bBxOsehz24Jd1XidoMyVWWsF4g4oFic9Onhb0/rs:fit:474:225:1/g:ce/aHR0cHM6Ly90c2U0/Lm1tLmJpbmcubmV0/L3RoP2lkPU9JUC4w/VXNvanZpTVdiRUZa/SXlKT0dfYkxBSGFI/YSZwaWQ9QXBp' alt='Express JS'/>
                <p className={styles.text}>Express JS</p>
            </div>
        </div>
    </div>
  )
}

export default Skills